Flup.service("tabs", function(flup){
   var that = this;

   function Tabs(_$tabsNav, opt){
      var t = this,
         _$navItems = _$tabsNav.children("[data-target-id]"),
         _groupId = _$tabsNav.data("group-id"),
         _$panes = $("[data-group-id='"+_groupId+"'][data-tab-id]");
      
      opt = opt||_$tabsNav.data("opt");
      
      t.changeTab = function(tabId){
         _$navItems.removeClass("active");
         _$navItems.filter("[data-target-id='"+tabId+"']").addClass("active");
         _$panes.removeClass("active");
         _$panes.filter("[data-tab-id='"+tabId+"']").addClass("active");
      }

      _$navItems.click(function(e){
         t.changeTab( $(this).data("target-id") );

         if(opt.scrollOnChange){
            $('html, body').scrollTop( $(this).closest(".container").offset().top );
         }
      });
      
      t.changeTab( _$navItems.eq(0).data("target-id") );
   }

   that.create = function(_$tabsNav, opt){
      return new Tabs(_$tabsNav, opt);
   }
});

Flup.link("tabs", function(flup, $elm, value){
   flup("tabs").create($elm);
});